import { TableColumn, TableStyles } from 'react-data-table-component';
import { WfUser } from 'src/api/wf/models/WfUser';
import { getDistance } from './WF_4_5_1_PropertiesMap';

type MapLocation = {
  latitude: number;
  longitude: number;
};

export const workerCustomStyles: TableStyles = {
  responsiveWrapper: {
    style: {
      border: '1px solid #000',
    },
  },
  table: {
    style: {
      backgroundColor: 'transparent',
      width: '100%',
      height: 'fit-content',
    },
  },
  headRow: {
    style: {
      backgroundColor: 'transparent',
      borderBottom: 'none',
      boxShadow: 'none',
    },
  },
  rows: {
    style: {
      border: 'none',
      backgroundColor: 'transparent',
      minHeight: '24px',
    },
  },
  headCells: {
    style: { border: 'none', padding: 0 },
  },
  cells: {
    style: {
      border: 'none',
      minHeight: '1.5rem',
      height: 'auto',
      whiteSpace: 'normal',
      overflowWrap: 'anywhere',
      padding: 4,
    },
  },
};

export const workerColumns = (
  center: MapLocation | null
): TableColumn<WfUser & { displayIndex?: number }>[] => {
  return [
    {
      cell: (row) => <div className="items-start bg-gray-100 pe-2">{row.displayIndex}</div>,
      width: '2rem',
    },
    {
      cell: (row) => <div className="pe-2">{row.telephoneNumber}</div>,
      grow: 1,
    },
    {
      cell: (row) => <div className="flex flex-row pe-2">{`${row.name ?? ''}`}</div>,
      width: '6rem',
    },
    {
      cell: (row) => <div className="flex flex-row pe-2">{row.ldapId ?? ''}</div>,
      width: '5rem',
    },
    {
      id: 'distance',
      cell: (row) => {
        if (
          center &&
          center.latitude != null &&
          row.location &&
          row.location.latitude != null &&
          row.location.longitude != null
        ) {
          const userLocation = getDistance(
            center.latitude,
            center.longitude,
            row.location.latitude,
            row.location.longitude
          );
          return <div className="">{`${userLocation.toFixed(1)} km`}</div>;
        }
        return <div className="">-</div>;
      },
      width: '3.8rem',
      right: true,
    },
  ];
};
